// Route chunk preloaders — used by <Link onMouseEnter={...}> to start
// downloading the lazy chunk before the user actually navigates. Each function
// returns the same promise that React.lazy uses, so the module cache is hit
// on first click (no double-fetch).
//
// NOTE: the paths here MUST match the ones used by React.lazy() in App.js
// exactly. Webpack (CRA) deduplicates dynamic imports by source string.

export const preloadHome          = () => import('../pages/Home');
export const preloadPricing       = () => import('../pages/Pricing');
export const preloadResources     = () => import('../pages/Resources');
export const preloadAbout         = () => import('../pages/About');
export const preloadBooking       = () => import('../pages/BookingPage');
export const preloadMiniGames     = () => import('../pages/MiniGames');
export const preloadChordDict     = () => import('../pages/ChordDictionary');
export const preloadStudentDash   = () => import('../pages/StudentDashboard');
export const preloadAdminDash     = () => import('../pages/AdminDashboard');
export const preloadTimeslotsMgmt = () => import('../pages/TimeslotsManagement');
